import { createContext, useContext, useEffect, useState } from "react";
import { HOME } from "./home";
import { PROGRAMME } from "./programme";
import { RO } from "./ro";

const DICT = { ...HOME, ...PROGRAMME };
Object.keys(RO).forEach((k) => {
  DICT[k] = { ...(DICT[k] || {}), ro: RO[k] };
});

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ro", label: "Română", flag: "🇷🇴" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
];

const RTL = ["ar"];
const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "fr");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL.includes(lang) ? "rtl" : "ltr";
  }, [lang]);

  const setLang = (code) => {
    localStorage.setItem("lang", code);
    setLangState(code);
  };

  const t = (key) => {
    const entry = DICT[key];
    if (!entry) return key;
    return entry[lang] ?? entry.en ?? entry.fr ?? key;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, isRTL: RTL.includes(lang) }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
